function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_di_5468:7567)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.3266 20.3071C26.271 21.4537 25.9048 22.5635 25.2671 23.5181C24.6792 24.3983 24.9161 25.5885 25.7963 26.1765C26.6765 26.7645 27.8667 26.5276 28.4547 25.6473C29.4783 24.1151 30.0661 22.3334 30.1554 20.4929C30.2447 18.6524 29.8321 16.8222 28.9618 15.198C28.0914 13.5738 26.7959 12.2168 25.214 11.2719C23.632 10.327 21.8229 9.82982 19.9802 9.83352C18.1376 9.83722 16.3305 10.3417 14.7524 11.2929C13.1742 12.2442 11.8842 13.6065 11.0204 15.2341C10.1566 16.8618 9.75129 18.6936 9.84799 20.5338C9.94479 22.3739 10.5398 24.1532 11.5695 25.6813C12.161 26.5592 13.3522 26.7913 14.23 26.1998C15.1079 25.6083 15.34 24.4171 14.7485 23.5392C14.107 22.5873 13.7364 21.4789 13.6761 20.3326C13.6158 19.1862 13.8683 18.0451 14.4064 17.0311C14.9445 16.0172 15.7481 15.1685 16.7312 14.576C17.7144 13.9834 18.8401 13.6691 19.988 13.6668C21.1359 13.6645 22.2628 13.9742 23.2483 14.5629C24.2338 15.1515 25.0408 15.9969 25.583 17.0087C26.1252 18.0204 26.3822 19.1606 26.3266 20.3071Z",
  fill: "#B0D9FF",
  stroke: "#B0D9FF",
  strokeWidth: 0.333333
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.3349 30.1082C16.7408 29.1879 16.1947 27.1496 17.115 25.5556C18.0353 23.9615 20.0736 23.4154 21.6677 24.3357C23.2617 25.256 23.8079 27.2943 22.8875 28.8883C21.9672 30.4824 19.9289 31.0285 18.3349 30.1082Z",
  fill: "#3370FF"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_di_5468:7567",
  x: 6.33463,
  y: 7.44476,
  width: 27.3327,
  height: 27.5549,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1.11111
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.66667
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.439216 0 0 0 0 0.596235 0 0 0 0 1 0 0 0 0.3 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_5468:7567"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_5468:7567",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.555556
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.833333
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.608958 0 0 0 0 0.805417 0 0 0 0 0.9875 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect2_innerShadow_5468:7567"
})));

function SvgIconFeat3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFeat3);
export default __webpack_public_path__ + "static/media/icon_feat_3.da02ec6b.svg";
export { ForwardRef as ReactComponent };